<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Tisk&aacute;rny B2338, B2442, M1242, MS321, MS421">
     Tisk&aacute;rny B2338, B2442, M1242, MS321, MS421
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_cs" title="Informace o&nbsp;bezpečnosti">
     Informace o&nbsp;bezpečnosti
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Konvence">
      Konvence
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Upozorněn&iacute; produktu">
      Upozorněn&iacute; produktu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_cs" title="Informace o tisk&aacute;rně">
     Informace o tisk&aacute;rně
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_cs" title="Vyhled&aacute;n&iacute; informac&iacute; o tisk&aacute;rně">
      Vyhled&aacute;n&iacute; informac&iacute; o tisk&aacute;rně
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_cs" title="V&yacute;běr um&iacute;stěn&iacute; tisk&aacute;rny">
      V&yacute;běr um&iacute;stěn&iacute; tisk&aacute;rny
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_cs" title="Konfigurace tisk&aacute;rny">
      Konfigurace tisk&aacute;rny
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_cs" title="Zapojov&aacute;n&iacute; kabelů">
      Zapojov&aacute;n&iacute; kabelů
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_cs" title="Použit&iacute; ovl&aacute;dac&iacute;ho panelu">
      Použit&iacute; ovl&aacute;dac&iacute;ho panelu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_cs" title="Popis stavu tlač&iacute;tka a kontrolky nap&aacute;jen&iacute;">
      Popis stavu tlač&iacute;tka a kontrolky nap&aacute;jen&iacute;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_cs" title="Zakl&aacute;d&aacute;n&iacute; pap&iacute;ru a speci&aacute;ln&iacute;ch m&eacute;di&iacute;">
     Zakl&aacute;d&aacute;n&iacute; pap&iacute;ru a speci&aacute;ln&iacute;ch m&eacute;di&iacute;
    </a>
   </p>
   <div id="divd0e736">
    <p class="toc-2-style">
     <a href="setting-size-and-type-of-specialty-media-topic.html#setting-size-and-type-of-specialty-media_cs" title="Nastaven&iacute; form&aacute;tu a typu speci&aacute;ln&iacute;ch m&eacute;di&iacute;">
      Nastaven&iacute; form&aacute;tu a typu speci&aacute;ln&iacute;ch m&eacute;di&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-h1-topic.html#configuring-universal-paper-settings-h1_cs" title="Nastaven&iacute; univerz&aacute;ln&iacute;ho form&aacute;tu pap&iacute;ru">
      Nastaven&iacute; univerz&aacute;ln&iacute;ho form&aacute;tu pap&iacute;ru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_cs" title="Vkl&aacute;d&aacute;n&iacute; do z&aacute;sobn&iacute;ků">
      Vkl&aacute;d&aacute;n&iacute; do z&aacute;sobn&iacute;ků
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_cs" title="Vkl&aacute;d&aacute;n&iacute; m&eacute;di&iacute; do univerz&aacute;ln&iacute;ho podavače">
      Vkl&aacute;d&aacute;n&iacute; m&eacute;di&iacute; do univerz&aacute;ln&iacute;ho podavače
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_cs" title="Propojov&aacute;n&iacute; z&aacute;sobn&iacute;ků">
      Propojov&aacute;n&iacute; z&aacute;sobn&iacute;ků
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_cs" title="Podpěra pap&iacute;ru">
     Podpěra pap&iacute;ru
    </a>
   </p>
   <div id="divd0e929">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-gsm-topic.html#supported-paper-sizes-gsm_cs" title="Podporovan&eacute; form&aacute;ty pap&iacute;ru">
      Podporovan&eacute; form&aacute;ty pap&iacute;ru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-gold-topic.html#supported-paper-types-gold_cs" title="Podporovan&eacute; typy pap&iacute;ru">
      Podporovan&eacute; typy pap&iacute;ru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-gsm-topic.html#supported-paper-weights-gsm_cs" title="Podporovan&eacute; gram&aacute;že pap&iacute;ru">
      Podporovan&eacute; gram&aacute;že pap&iacute;ru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_cs" title="Nepřijateln&yacute; pap&iacute;r">
      Nepřijateln&yacute; pap&iacute;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_cs" title="Použit&iacute; recyklovan&eacute;ho pap&iacute;ru">
      Použit&iacute; recyklovan&eacute;ho pap&iacute;ru
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_cs" title="Tisk">
     Tisk
    </a>
   </p>
   <div id="divd0e1536">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_cs" title="Tisk z&nbsp;poč&iacute;tače">
      Tisk z&nbsp;poč&iacute;tače
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e1562" title="Tisk pomoc&iacute; mobiln&iacute;ho zař&iacute;zen&iacute;">
      Tisk pomoc&iacute; mobiln&iacute;ho zař&iacute;zen&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_cs" title="Tisk seznamu uk&aacute;zek p&iacute;sma">
      Tisk seznamu uk&aacute;zek p&iacute;sma
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_cs" title="Porozuměn&iacute; nab&iacute;dk&aacute;m tisk&aacute;rny">
     Porozuměn&iacute; nab&iacute;dk&aacute;m tisk&aacute;rny
    </a>
   </p>
   <div id="divd0e1706">
    <p class="toc-2-style">
     <a href="menus-map-topic.html#menus-map_cs" title="Sch&eacute;ma nab&iacute;dek">
      Sch&eacute;ma nab&iacute;dek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e1885" title="Zař&iacute;zen&iacute;">
      Zař&iacute;zen&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e2851" title="Tisk">
      Tisk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e3828" title="Pap&iacute;r">
      Pap&iacute;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e4065" title="S&iacute;ť/Porty">
      S&iacute;ť/Porty
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e5545" title="Zpr&aacute;vy">
      Zpr&aacute;vy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-group.html#d0e5674" title="Ře&scaron;en&iacute; probl&eacute;mů">
      Ře&scaron;en&iacute; probl&eacute;mů
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_cs" title="Tisk str&aacute;nky nastaven&iacute; nab&iacute;dek">
      Tisk str&aacute;nky nastaven&iacute; nab&iacute;dek
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_cs" title="Zabezpečen&iacute; tisk&aacute;rny">
     Zabezpečen&iacute; tisk&aacute;rny
    </a>
   </p>
   <div id="divd0e5728">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_cs" title="Vyhled&aacute;n&iacute; slotu zabezpečen&iacute;">
      Vyhled&aacute;n&iacute; slotu zabezpečen&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_cs" title="Vymaz&aacute;n&iacute; paměti tisk&aacute;rny">
      Vymaz&aacute;n&iacute; paměti tisk&aacute;rny
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_cs" title="Obnoven&iacute; v&yacute;choz&iacute;ch tov&aacute;rn&iacute;ch nastaven&iacute;">
      Obnoven&iacute; v&yacute;choz&iacute;ch tov&aacute;rn&iacute;ch nastaven&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_cs" title="Prohl&aacute;&scaron;en&iacute; o nest&aacute;losti">
      Prohl&aacute;&scaron;en&iacute; o nest&aacute;losti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_cs" title="&Uacute;držba tisk&aacute;rny">
     &Uacute;držba tisk&aacute;rny
    </a>
   </p>
   <div id="divd0e5900">
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e5905" title="Pr&aacute;ce v&nbsp;s&iacute;ti">
      Pr&aacute;ce v&nbsp;s&iacute;ti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_cs" title="Či&scaron;těn&iacute; tisk&aacute;rny">
      Či&scaron;těn&iacute; tisk&aacute;rny
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies.html#ordering-supplies_cs" title="Objedn&aacute;n&iacute; č&aacute;st&iacute; a spotřebn&iacute;ho materi&aacute;lu">
      Objedn&aacute;n&iacute; č&aacute;st&iacute; a spotřebn&iacute;ho materi&aacute;lu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e6526" title="V&yacute;měna č&aacute;st&iacute; a spotřebn&iacute;ho materi&aacute;lu">
      V&yacute;měna č&aacute;st&iacute; a spotřebn&iacute;ho materi&aacute;lu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer.html#moving-the-printer_cs" title="Přemisťov&aacute;n&iacute; tisk&aacute;rny">
      Přemisťov&aacute;n&iacute; tisk&aacute;rny
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e6725" title="&Uacute;spora energie a&nbsp;pap&iacute;ru">
      &Uacute;spora energie a&nbsp;pap&iacute;ru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#d0e6873" title="Recyklace">
      Recyklace
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_cs" title="Odstraňov&aacute;n&iacute; uv&iacute;znut&iacute;">
     Odstraňov&aacute;n&iacute; uv&iacute;znut&iacute;
    </a>
   </p>
   <div id="divd0e6927">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_cs" title="Prevence uv&iacute;znut&iacute;">
      Prevence uv&iacute;znut&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_cs" title="Rozpozn&aacute;n&iacute; m&iacute;st uv&iacute;znut&iacute; pap&iacute;ru">
      Rozpozn&aacute;n&iacute; m&iacute;st uv&iacute;znut&iacute; pap&iacute;ru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_cs" title="Zaseknut&iacute; pap&iacute;ru ve dv&iacute;řk&aacute;ch&nbsp;A">
      Zaseknut&iacute; pap&iacute;ru ve dv&iacute;řk&aacute;ch&nbsp;A
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_cs" title="Uv&iacute;znut&iacute; pap&iacute;ru v&nbsp;zadn&iacute;ch dv&iacute;řk&aacute;ch">
      Uv&iacute;znut&iacute; pap&iacute;ru v&nbsp;zadn&iacute;ch dv&iacute;řk&aacute;ch
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_cs" title="Uv&iacute;znut&iacute; pap&iacute;ru ve standardn&iacute;m odkladači">
      Uv&iacute;znut&iacute; pap&iacute;ru ve standardn&iacute;m odkladači
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_cs" title="Zaseknut&yacute; pap&iacute;r v jednotce pro oboustrann&yacute; tisk">
      Zaseknut&yacute; pap&iacute;r v jednotce pro oboustrann&yacute; tisk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_cs" title="Uv&iacute;znut&iacute; pap&iacute;ru v&nbsp;z&aacute;sobn&iacute;c&iacute;ch">
      Uv&iacute;znut&iacute; pap&iacute;ru v&nbsp;z&aacute;sobn&iacute;c&iacute;ch
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_cs" title="Uv&iacute;znut&iacute; pap&iacute;ru v&nbsp;univerz&aacute;ln&iacute;m podavači">
      Uv&iacute;znut&iacute; pap&iacute;ru v&nbsp;univerz&aacute;ln&iacute;m podavači
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_cs" title="Ře&scaron;en&iacute; probl&eacute;mů">
     Ře&scaron;en&iacute; probl&eacute;mů
    </a>
   </p>
   <div id="divd0e7203">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e7206" title="Probl&eacute;my se s&iacute;ťov&yacute;m připojen&iacute;m">
      Probl&eacute;my se s&iacute;ťov&yacute;m připojen&iacute;m
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e7353" title="Probl&eacute;my se spotřebn&iacute;m materi&aacute;lem">
      Probl&eacute;my se spotřebn&iacute;m materi&aacute;lem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e7499" title="Pot&iacute;že s&nbsp;pod&aacute;v&aacute;n&iacute;m pap&iacute;ru">
      Pot&iacute;že s&nbsp;pod&aacute;v&aacute;n&iacute;m pap&iacute;ru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-blank-or-white-pages-topic.html#d0e7885" title="Probl&eacute;my s&nbsp;tiskem">
      Probl&eacute;my s&nbsp;tiskem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_cs" title="Kontaktov&aacute;n&iacute; z&aacute;kaznick&eacute; podpory">
      Kontaktov&aacute;n&iacute; z&aacute;kaznick&eacute; podpory
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-and-migrating-chapter.html#upgrading-and-migrating-chapter_cs" title="Aktualizace a migrace">
     Aktualizace a migrace
    </a>
   </p>
   <div id="divd0e10237">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e10240" title="Hardware">
      Hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e10400" title="Software">
      Software
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e10476" title="Firmware">
      Firmware
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_cs" title="Pozn&aacute;mky">
     Pozn&aacute;mky
    </a>
   </p>
   <div id="divd0e10545">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10548" title="Informace o produktu">
      Informace o produktu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10565" title="Pozn&aacute;mky k vyd&aacute;n&iacute;">
      Pozn&aacute;mky k vyd&aacute;n&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_cs" title="Ochrann&eacute; zn&aacute;mky">
      Ochrann&eacute; zn&aacute;mky
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_cs" title="Licenčn&iacute; informace">
      Licenčn&iacute; informace
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_cs" title="&Uacute;rovně hluku">
      &Uacute;rovně hluku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_cs" title="Směrnice OEEZ (o odpadn&iacute;ch elektrick&yacute;ch a elektronick&yacute;ch zař&iacute;zen&iacute;ch)">
      Směrnice OEEZ (o odpadn&iacute;ch elektrick&yacute;ch a elektronick&yacute;ch zař&iacute;zen&iacute;ch)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10667" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_cs" title="Likvidace produktu">
      Likvidace produktu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10701" title="Lithium-iontov&aacute; nab&iacute;jec&iacute; baterie">
      Lithium-iontov&aacute; nab&iacute;jec&iacute; baterie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_cs" title="Nař&iacute;zen&iacute; (EU) 2023/1542">
      Nař&iacute;zen&iacute; (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_cs" title="Vr&aacute;cen&iacute; kazet Lexmark za &uacute;čelem opětovn&eacute;ho použit&iacute; nebo recyklace">
      Vr&aacute;cen&iacute; kazet Lexmark za &uacute;čelem opětovn&eacute;ho použit&iacute; nebo recyklace
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_cs" title="Upozorněn&iacute; na citlivost vůči statick&eacute; elektřině">
      Upozorněn&iacute; na citlivost vůči statick&eacute; elektřině
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_cs" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_cs" title="Informace o teplotě">
      Informace o teplotě
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_cs" title="Upozorněn&iacute; ohledně laseru">
      Upozorněn&iacute; ohledně laseru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_cs" title="Spotřeba energie">
      Spotřeba energie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10941" title="Z&aacute;konn&eacute; požadavky t&yacute;kaj&iacute;c&iacute; se bezdr&aacute;tov&yacute;ch v&yacute;robků">
      Z&aacute;konn&eacute; požadavky t&yacute;kaj&iacute;c&iacute; se bezdr&aacute;tov&yacute;ch v&yacute;robků
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_cs" title="Pozn&aacute;mka k modul&aacute;rn&iacute;m komponent&aacute;m">
      Pozn&aacute;mka k modul&aacute;rn&iacute;m komponent&aacute;m
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_cs" title="Vystaven&iacute; z&aacute;řen&iacute; r&aacute;diov&yacute;ch vln">
      Vystaven&iacute; z&aacute;řen&iacute; r&aacute;diov&yacute;ch vln
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_cs" title="Prohl&aacute;&scaron;en&iacute; o dodržen&iacute; směrnic EU">
      Prohl&aacute;&scaron;en&iacute; o dodržen&iacute; směrnic EU
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10975" title="Prohl&aacute;&scaron;en&iacute; o dodržen&iacute; směrnic EU">
      Prohl&aacute;&scaron;en&iacute; o dodržen&iacute; směrnic EU
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue